module.exports = __webpack_public_path__ + "static/img/cha-lr-3.42eeb9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-lr-3.png
// module id = 3q13
// module chunks = 1